"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _constant = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant2 = require("./constant");
var _productCategoryCard = require("./productCategoryCard.proptypes");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "ProductCategoryCard__ContainerWrapper",
  componentId: "sc-vst7nk-0"
})(["display:grid;grid-column:span 2;outline:none !important;scroll-snap-align:start;height:100%;box-sizing:border-box;padding-left:0px !important;", ";"], function (_ref) {
  var width = _ref.width;
  return width && "width: ".concat(width, "\n   ");
});
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "ProductCategoryCard__StyledContainer",
  componentId: "sc-vst7nk-1"
})(["margin:", ";box-sizing:border-box;background-color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.tiny);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.default;
});
var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "ProductCategoryCard__TextContainer",
  componentId: "sc-vst7nk-2"
})(["padding:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.tiny, " 0px 0px 0px");
});
var ProductCategoryCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "ProductCategoryCard__ProductCategoryCardWrapper",
  componentId: "sc-vst7nk-3"
})(["cursor:pointer;background-color:", ";outline:0 !important;border-radius:", ";height:100%;width:100%;display:flex;align-items:center;flex-direction:column;"], function (_ref5) {
  var color = _ref5.color,
    theme = _ref5.theme;
  return color && theme.colors[color] || theme.colors.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius.normal;
});
var renderText = function renderText(type) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'neutral';
  var strikethrough = arguments.length > 2 ? arguments[2] : undefined;
  var dir = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ltr';
  var theme = arguments.length > 4 ? arguments[4] : undefined;
  var text = arguments.length > 5 ? arguments[5] : undefined;
  var customProperties = arguments.length > 6 ? arguments[6] : undefined;
  return text && /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    direction: dir,
    strikethrough: strikethrough,
    type: type,
    textLimit: 12,
    textAlign: "center",
    color: color,
    theme: theme
  }, customProperties), text);
};
var ProductCategoryCard = function ProductCategoryCard(props) {
  var index = props.index,
    data = props.data,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    width = props.width,
    hoverEffect = props.hoverEffect,
    focusEffect = props.focusEffect,
    imageHoverAnimation = props.imageHoverAnimation,
    handleClick = props.handleClick,
    fireGtm = props.fireGtm,
    color = props.color,
    chinaDisclaimerListener = props.chinaDisclaimerListener,
    isCnDomain = props.isCnDomain,
    isMobile = props.isMobile,
    idConfig = props.idConfig,
    enableProgressiveImageLoading = props.enableProgressiveImageLoading,
    lazyLoadImage = props.lazyLoadImage,
    customImageMinSize = props.customImageMinSize;
  var _ref7 = idConfig || {},
    parentName = _ref7.parentName,
    widgetName = _ref7.widgetName;
  var _useState = (0, _react.useState)('productCategoryCard'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dynamicID = _useState2[0],
    setId = _useState2[1];
  (0, _react.useEffect)(function () {
    var url = 'productCategoryCard';
    if (parentName) {
      url = "".concat(parentName, "-productCategoryCard");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  var gtmEventData = props.gtmEventData;
  var url = data.url,
    image = data.image,
    title = data.title,
    newTab = data.newTab,
    cnDisclaimerLine1 = data.cnDisclaimerLine1,
    cndisclaimerLine1 = data.cndisclaimerLine1,
    lowResolutionImageUrl = data.lowResolutionImageUrl;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var minHeight = isMobile ? '80px' : '100px';
  if (customImageMinSize) {
    minHeight = customImageMinSize;
  }
  var handleOnClick = function handleOnClick(e) {
    if ((cnDisclaimerLine1 || cndisclaimerLine1) && isCnDomain) {
      return chinaDisclaimerListener && chinaDisclaimerListener(data);
    }
    if (!handleClick && url) {
      gtmEventData = gtmEventData ? gtmEventData.replace('{{productid}}', data.productID || null).replace('{{cardtitle}}', data.title || null).replace('{{redirecturl}}', data.url.includes('airasiago') ? 'external' : 'internal') : null; // eslint-disable-next-line radix

      gtmEventData = gtmEventData ? gtmEventData.replace('{{cardposition}}', parseInt(index) + 1 || null) : null; // eslint-disable-next-line no-unused-expressions

      fireGtm ? fireGtm(gtmEventData, true) : null;
      if (e.target && e.target.getAttribute('id') === 'cta_link') return null;
      return newTab === 'TRUE' || newTab === '' ? window.open(url, '_blank') : window.open(url, '_self');
    }
    return handleClick && handleClick(e, index);
  };
  var tabIndex = !accessible ? '-1' : '0';
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  var getMain = function getMain() {
    return dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ContainerWrapper, (0, _extends2.default)({
      width: width,
      focusEffect: focusEffect
    }, customProperties), /*#__PURE__*/_react.default.createElement(StyledContainer, {
      hoverEffect: hoverEffect
    }, /*#__PURE__*/_react.default.createElement(ProductCategoryCardWrapper, {
      id: dynamicID,
      tabIndex: tabIndex,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, function () {
          return handleOnClick(e);
        }, _constant.KEY_CODE.ENTER);
      },
      onClick: function onClick(e) {
        return handleOnClick(e);
      },
      color: color,
      role: "link"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      centerFocus: true,
      hoverAnimation: imageHoverAnimation,
      src: image,
      height: minHeight,
      width: minHeight,
      radius: "50%",
      theme: theme,
      accessible: false,
      lowResolutionImageUrl: lowResolutionImageUrl,
      enableProgressiveImageLoading: enableProgressiveImageLoading,
      lazyLoadImage: lazyLoadImage
    }), /*#__PURE__*/_react.default.createElement(TextContainer, null, title && renderText('small', _constant2.TOKENS.TITLE.COLOR, false, 'ltr', theme, title)))))) : null;
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
ProductCategoryCard.propTypes = _productCategoryCard.ProductCategoryCardPropTypes.PropTypes;
ProductCategoryCard.defaultProps = _productCategoryCard.ProductCategoryCardPropTypes.DefaultProps;
var _default = ProductCategoryCard;
exports.default = _default;